import { useMemo } from 'react';
import { world } from '../languages';
import { AVAILABLE_WORLDS } from '../languages/constants';
import getDEGradesWithClassesWithinRange from '../utils/grades/get-de-grades-with-classes-within-range';
import getESGradesWithClassesWithinRange from '../utils/grades/get-es-grades-with-classes-within-range';

type UseGradesProps = { materialClassGrades: MaterialClassGrade[] };

const useGrades = (props: UseGradesProps) => {
    const { materialClassGrades } = props;

    return useMemo(() => {
        if (!materialClassGrades?.length) {
            return [];
        }

        if (world === AVAILABLE_WORLDS.DE) {
            return getDEGradesWithClassesWithinRange(materialClassGrades);
        }
        if (world === AVAILABLE_WORLDS.ES) {
            return getESGradesWithClassesWithinRange(materialClassGrades);
        }

        return materialClassGrades.map((grade) => grade.title);
    }, [JSON.stringify(materialClassGrades), world]);
};

export default useGrades;
